import { AIChatMessage, AIChatMessageRecord, AIChatSession } from '@/services/api';

export interface ChatPreset {
  id: string;
  label: string;
}

export interface PlayerOption {
  playerId: number;
  name: string;
  position: string;
}

export interface AIChatPanelProps {
  onSendMessage?: (messages: AIChatMessage[], preset?: string, sessionId?: string) => Promise<{ reply: string; sessionId: string }>;
  onSendLatestMessage?: (message: string, preset?: string, sessionId?: string) => Promise<{ reply: string; sessionId: string }>;
  presets: ChatPreset[];
  playerOptions?: PlayerOption[];
  onPlayerFocusChange?: (playerId: number | null) => void;
  title?: string;
  entityType: 'match' | 'player' | 'league_match';
  entityId: string;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  initialSessionId?: string;
  listSessions?: () => Promise<AIChatSession[]>;
  getSessionMessages?: (sessionId: string) => Promise<AIChatMessageRecord[]>;
  deleteSession?: (sessionId: string) => Promise<void>;
  maxMessageLength?: number;
}

export const formatDate = (dateStr: string) => {
  const d = new Date(dateStr);
  return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
};
